import { lazy } from 'react';

// Compliance: TS-strict surface anchored on /compliance/summary +
// /compliance/controls + /compliance/categories + /compliance/drift/summary.
// Cross-client comparison + the rich attestation chain stay as future work —
// backend doesn't expose them yet.
// Credential vault: rotation-first narrative on /vault/credentials +
// /vault/folders + /vault/stats + /vault/audit. Reveal/rotate console stays
// at /vault/credentials/:id — this surface links into it rather than
// duplicating secrets-handling UX.
export const CredentialVault = lazy(() => import('@/capabilities/cerberus/pages/CredentialVault'));

// Cerberus (Credential Vault)
// Cluster collapse 2026-04-28: VaultShared + VaultAudit absorbed into
// CredentialVault (tabs). VaultDashboard archived. VaultSettings stays —
// mounted at /settings/vault (canonical), with /vault/settings redirecting.
export const VaultSettings = lazy(() =>
  import('@/capabilities/cerberus/pages/VaultSettings').then((m) => ({ default: m.VaultSettings }))
);

// Credential Health is a separate capability embedded into the vault surface;
// Cerberus remains the credential-storage and reveal boundary.
export { CredentialHealthScanDetail } from '@/capabilities/credential-health/public/pages';
